import { createContext, ReactNode } from "react";

export type userType = "internal" | "external";

export interface UserTypeProps {
  userType: userType;
}
export const UserTypeContext = createContext<UserTypeProps>({
  userType: "external",
});

export function UserTypeProvider({ type, children }: { type: userType; children: ReactNode }) {
  return <UserTypeContext.Provider value={{ userType: type }}>{children}</UserTypeContext.Provider>;
}
